import { showNotification } from "../../notification/actions";
import { captureException } from "@sentry/browser";

import { NEW_PLAN } from "../types";
import { Dispatch } from "redux";
import { PackActionTypes } from "../models/packActions";
import { IStateTree } from "../../interfaces";
import { AxiosInstance, AxiosResponse } from "axios";
import { IPlan } from "../../../../common/types";

interface ICreatePlanResponse {
    plan?: IPlan, limit?: number,
}
export default (data: { name: {[lang: string]: string}, packId: string, description: {[lang: string]: string}}, callback: (res: AxiosResponse<ICreatePlanResponse>) => void) =>
    async (dispatch: Dispatch<PackActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<ICreatePlanResponse>("/new-plan", data);
        dispatch({
            type: NEW_PLAN,
            payload: res,
        });
        callback(res);
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};